import { BoundSelectField, BoundSelectFieldProps } from "@homebound/beam";
import {
  LocationsSelectField_LocationFragment,
  useLocationsQuery,
} from "src/components/autoPopulateSelects/LocationsSelectField.generated";
import { LocationsFilter } from "src/generated/graphqlTypes";

// type LocationsBoundSelectFieldProps = {
//   field: FieldState<any, string | null | undefined>;
//   disabledOptions?: string[];
//   label?: string;
//   placeholder?: string;
// }

type LocationsBoundSelectFieldProps = Omit<
  BoundSelectFieldProps<LocationsSelectField_LocationFragment, string>,
  "options" | "multiselect" | "getOptionLabel" | "getOptionValue"
> & {
  getOptionLabel?: (o: LocationsSelectField_LocationFragment) => string;
  getOptionValue?: (o: LocationsSelectField_LocationFragment) => string;
  filter?: LocationsFilter;
};

export function LocationsBoundSelectField(props: LocationsBoundSelectFieldProps) {
  const {
    placeholder = "Select a Location",
    getOptionLabel = (o) => o.name,
    getOptionValue = (o) => o.id,
    filter,
    ...otherProps
  } = props;
  const { data, loading } = useLocationsQuery({
    fetchPolicy: "cache-and-network",
    ...(filter && { variables: { filter } }),
  });

  return (
    <BoundSelectField
      {...otherProps}
      placeholder={loading ? "Loading..." : placeholder}
      options={data?.locations ?? []}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
    />
  );
}
